import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
    baseURL: "/api", // url = base url + request url
    timeout: 100000,
});
export default service;
